import { render, staticRenderFns } from "./SecuritiesDeletionModal.vue?vue&type=template&id=212062ec&scoped=true&"
import script from "./SecuritiesDeletionModal.vue?vue&type=script&lang=ts&"
export * from "./SecuritiesDeletionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212062ec",
  null
  
)

export default component.exports